import {Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "@fedeltapointofsale/data-client";
import {Router, Routes} from "@angular/router";
import {NavLayoutComponent} from "./main/nav-layout/nav-layout.component";
import {AuthGuardService} from "./auth-guard.service";
import {buildRoutes} from "./main/main.routing";
import {RoutingDiscoveryService} from "./routing-discovery.service";
import {CustomerSupportMessagingService} from "./customer-support-messaging/customer-support-messaging.service";
import {AnalyticsService} from "./analytics/analytics.service";
import {Subscription} from "rxjs";

@Component({
    selector: "wbo-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {
    public loginRevokedSubscription: Subscription;

    constructor(routingDiscoveryService: RoutingDiscoveryService,
                private router: Router,
                private authService: AuthService,
                private translate: TranslateService,
                private messagingService: CustomerSupportMessagingService,
                private analyticsService: AnalyticsService,
                protected element: ElementRef,
                protected ngZone: NgZone) {
        const mainChildren: Routes = buildRoutes();

        routingDiscoveryService.routes = mainChildren;

        this.router.config.push({
            children: mainChildren,
            component: NavLayoutComponent,
            path: "main",
            canActivate: [AuthGuardService]
        });
        this.router.resetConfig(this.router.config);

        this.translate.setDefaultLang("en");
        this.translate.getTranslation("en");
        this.translate.use(translate.getBrowserLang());
    }

    ngOnInit(): void {
        this.analyticsService.init();
        this.messagingService.init();
        this.loginRevokedSubscription = this.authService.loginRevoked$.subscribe({
            next: () => {
                this.router.navigate(["/login"]);
            },
            error: (error: any) => {
                this.router.navigate(["/login"]);
            }
        });

        this.ngZone.runOutsideAngular(() => {
            this.element.nativeElement.addEventListener("dragover", (dragEvent: DragEvent) => {
                dragEvent.preventDefault();
                dragEvent.stopPropagation();
                dragEvent.dataTransfer.dropEffect = "none";
            });
        });
    }

    ngOnDestroy(): void {
        this.loginRevokedSubscription.unsubscribe();
    }

    @HostListener("drop", ["$event"])
    private fileDropped(dragEvent: DragEvent): void {
        dragEvent.preventDefault();
        dragEvent.stopPropagation();
    }
}
